"use client"
/**
 * Returns the value of a cookie
 * @param name The name of the cookie
 * @returns the cookie's value as a string or undefined if cookie does not exist
 */
export function getCookie(name: string): string | undefined {
  if (typeof document !== 'undefined') {
    const value = '; ' + document.cookie
    const parts = value.split('; ' + name + '=')

    if (parts.length === 2) {
      return parts?.pop()?.split(';').shift()
    }
  }
}